/*
 * COPYRIGHT 2023-2024 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */

const KC_CONFIG = {
    "url": "https://auth.yospace.com/auth",
    "realm": "YospaceCDS",
    "clientId": "lefort-poc-euw1-001"
}

export default KC_CONFIG;
